import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule } from '@angular/forms';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { RouterModule, Routes } from '@angular/router';
import { Component } from '@angular/core';

import { TokenInterceptor } from './core/token.interceptor';
import { AuthGuard, GuestGuard } from './core/auth.guard';
import { AppDatePipe } from './core/app-date.pipe';
import { ToastsComponent } from './core/toast.service';
import { DialogComponent } from './core/dialog.service';

import { SigninComponent } from './auth/signin.component';
import { SignupComponent } from './auth/signup.component';
import { ForgotPasswordComponent, ResetPasswordComponent } from './auth/password-recovery.component';
import { ShellComponent } from './layout/shell.component';
import { DashboardComponent, MyAccountComponent, ProfileComponent, ChangePasswordComponent } from './member/member.components';
import { SecurityComponent, ForgotUsernameComponent } from './member/security.component';
import { MyResumesComponent, ServicePageComponent } from './resume/my-resumes.component';
import { ResumeEditorComponent } from './resume/resume-editor.component';
import { ResumePreviewComponent } from './resume/resume-preview.component';
import { UserManagementComponent } from './admin/user-management.component';
import { FundamentalSettingsComponent } from './admin/fundamental-settings.component';
import { EssentialSettingsComponent } from './admin/essential-settings.component';

@Component({
  selector: 'app-root',
  template: `<router-outlet></router-outlet><app-toasts></app-toasts><app-dialog></app-dialog>`
})
export class AppComponent {}

const routes: Routes = [
  { path: 'signin', component: SigninComponent, canActivate: [GuestGuard] },
  { path: 'signup', component: SignupComponent, canActivate: [GuestGuard] },
  { path: 'forgot-password', component: ForgotPasswordComponent },
  { path: 'reset-password', component: ResetPasswordComponent },
  { path: 'forgot-username', component: ForgotUsernameComponent },
  {
    path: '', component: ShellComponent, canActivate: [AuthGuard],
    children: [
      { path: '', pathMatch: 'full', redirectTo: 'dashboard' },
      { path: 'dashboard', component: DashboardComponent, canActivate: [AuthGuard], data: { module: 'DASHBOARD' } },
      { path: 'my-account', component: MyAccountComponent, canActivate: [AuthGuard], data: { module: 'DASHBOARD' } },
      { path: 'profile', component: ProfileComponent, canActivate: [AuthGuard], data: { module: 'MY_PROFILE' } },
      { path: 'security', component: SecurityComponent, canActivate: [AuthGuard], data: { module: 'CHANGE_PASSWORD' } },
      { path: 'security/:panel', component: SecurityComponent, canActivate: [AuthGuard], data: { module: 'CHANGE_PASSWORD' } },
      { path: 'change-password', redirectTo: 'security/change-password', pathMatch: 'full' },
      { path: 'my-resumes', component: MyResumesComponent, canActivate: [AuthGuard], data: { module: 'MY_RESUMES' } },
      { path: 'my-resumes/:slug', component: ServicePageComponent, canActivate: [AuthGuard], data: { module: 'MY_RESUMES' } },
      { path: 'my-resumes/:slug/:id', component: ResumeEditorComponent, canActivate: [AuthGuard], data: { module: 'MY_RESUMES' } },
      { path: 'admin/users', component: UserManagementComponent, canActivate: [AuthGuard], data: { module: 'USER_MANAGEMENT' } },
      { path: 'admin/fundamental-settings', component: FundamentalSettingsComponent, canActivate: [AuthGuard], data: { module: 'FUNDAMENTAL_SETTINGS' } },
      { path: 'admin/essential-settings', component: EssentialSettingsComponent, canActivate: [AuthGuard], data: { module: 'ESSENTIAL_SETTINGS', superAdminOnly: true } }
    ]
  },
  { path: '**', redirectTo: '' }
];

@NgModule({
  declarations: [
    AppComponent, ToastsComponent, DialogComponent, AppDatePipe,
    SigninComponent, SignupComponent, ForgotPasswordComponent, ResetPasswordComponent,
    ShellComponent, DashboardComponent, MyAccountComponent, ProfileComponent, ChangePasswordComponent, SecurityComponent, ForgotUsernameComponent,
    MyResumesComponent, ServicePageComponent, ResumeEditorComponent, ResumePreviewComponent,
    UserManagementComponent, FundamentalSettingsComponent, EssentialSettingsComponent
  ],
  imports: [BrowserModule, FormsModule, HttpClientModule, RouterModule.forRoot(routes, { scrollPositionRestoration: 'top' })],
  providers: [{ provide: HTTP_INTERCEPTORS, useClass: TokenInterceptor, multi: true }],
  bootstrap: [AppComponent]
})
export class AppModule {}
